import { TiModal } from "@ti/ui-mobile";
import { useT } from "@/utils/intlUtils";
import { getIsOversea } from "@/utils/environmentUtils";
import telIcon from "@/assets/address/tel.png";
import emailIcon from "@/assets/address/email.png";

import {
  ListItemContainer,
  ContactInformation,
  AddressInformation,
  ClearanceInfo,
  ClearanceInfoItemInfo,
} from "./styles";

const isOversea = getIsOversea();

export default (props: any) => {
  const {
    control,
    record,
    contactNumber,
    countryName,
    cityNames,
    clearanceContactNumber,
  } = props;

  const { addressCfgClearanceDto = {} } = record;

  const t = useT();

  return (
    <TiModal.Bottom
      title={t("地址详情")}
      {...control}
      closeOnMaskClick
      actions={false}
      bodyStyle={{ height: "50vh" }}
    >
      <ListItemContainer>
        <span className="title">{record?.contactPerson}</span>
        <ContactInformation>
          <img src={telIcon} alt="" />
          <span>{contactNumber}</span>
        </ContactInformation>
        <ContactInformation>
          <img src={emailIcon} alt="" />
          <span>{record?.email || "-"}</span>
        </ContactInformation>
        {isOversea && (
          <AddressInformation>
            <span>
              {t("收货抬头")}：{record?.invoiceTitle || "-"}
            </span>
          </AddressInformation>
        )}
        <AddressInformation>
          <span>
            {t("收货地区")}：{countryName} {cityNames}
          </span>
        </AddressInformation>
        <AddressInformation>
          <span>
            {t("收货地址")}： {record?.address}
          </span>
        </AddressInformation>
        {isOversea && (
          <ClearanceInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("清关公司")}：{addressCfgClearanceDto?.clearanceCompany}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("清关地址")}：{addressCfgClearanceDto?.clearanceAddress}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("联系人")}：{addressCfgClearanceDto?.contactPerson}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("联系电话")}：{clearanceContactNumber}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("联系邮箱")}：{addressCfgClearanceDto?.email}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("邮编")}：{addressCfgClearanceDto?.postCode}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("税号")}：{addressCfgClearanceDto?.taxId}
              </span>
            </ClearanceInfoItemInfo>
            <ClearanceInfoItemInfo>
              <span>
                {t("EORI号")}：{addressCfgClearanceDto?.economicNumber}
              </span>
            </ClearanceInfoItemInfo>
          </ClearanceInfo>
        )}
      </ListItemContainer>
    </TiModal.Bottom>
  );
};
